// libs
import React, { memo } from 'react';
import get from 'lodash/get';
import { styled } from '@nykaa/ui-components';

// defs
import { ILandingPageWidget, IWidgetItems } from 'shared/components/AdPlatformWidgets/types';

// componenets
import { WidgetsContainer } from 'shared/components/AdPlatformWidgets/Desktop/components/Grid/styles';
import Card from 'shared/components/AdPlatformWidgets/Desktop/components/Grid/components/Card/Card.tsx';

// helpers
import { getGridParams } from 'shared/components/AdPlatformWidgets/Desktop/components/Grid/helpers';

const SplitBannerWrapper = styled.div`
  display: flex;
`;

const CustomCard = styled(Card)<{ cardWidth: number }>`
  margin: 0;
  padding: 0;
  width: ${(props) => (props.cardWidth ? `${props.cardWidth}%` : '100%')};

  &:hover {
    box-shadow: none;
  }
`;

interface ISplitBannerProps {
  widget: ILandingPageWidget;
}

function SplitBanner({ widget }: ISplitBannerProps) {
  const items = get(widget, 'widget_data.children', []);
  const inventoryName = get(widget, 'inventory_name', '');
  const { backgroundColor, textColor } = getGridParams(widget);
  const totalCards = items.length;

  return (
    <WidgetsContainer backgroundColor={backgroundColor} textColor={textColor}>
      <SplitBannerWrapper>
        {items.map((item: IWidgetItems, idx: number) => {
          return (
            <CustomCard
              key={idx}
              childCount={idx + 1}
              numOfColumns={totalCards}
              widgetItem={item}
              inventoryName={inventoryName}
              textColor={textColor}
              contentAlign={'contentAlign'}
              cardWidth={100 / totalCards}
            />
          );
        })}
      </SplitBannerWrapper>
    </WidgetsContainer>
  );
}

export default memo(SplitBanner);
